import { render, staticRenderFns } from "./uiContactsWhite.vue?vue&type=template&id=87f4ffde&scoped=true"
import script from "./uiContactsWhite.vue?vue&type=script&lang=js"
export * from "./uiContactsWhite.vue?vue&type=script&lang=js"
import style0 from "./uiContactsWhite.vue?vue&type=style&index=0&id=87f4ffde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f4ffde",
  null
  
)

export default component.exports